"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _glamor = require("glamor");

var _components = require("components");

var _applications = require("redux/modules/applications");

var _Table = require("@quixeltools/quixel-ui-library/dist/components/common/website/Table");

var _Table2 = _interopRequireDefault(_Table);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableSection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 2.578,
    large: [2.578, 3.4375]
  }
}));

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var table = (0, _glamor.css)({
  "& th:nth-child(1)": { width: "25%" },
  "& th:nth-child(2)": { width: "50%" },
  "& th:nth-child(3)": { width: "25%" },

  "& tbody": {
    color: _css.colors.white,
    fontSize: {
      smallMedium: 1,
      large: [1, 1.125]
    }
  }
});

var UserApplications = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(UserApplications, _React$Component);

  function UserApplications(props) {
    (0, _classCallCheck3.default)(this, UserApplications);
    return (0, _possibleConstructorReturn3.default)(this, (UserApplications.__proto__ || (0, _getPrototypeOf2.default)(UserApplications)).call(this));
  }

  (0, _createClass3.default)(UserApplications, [{
    key: "onCreateClick",
    value: function onCreateClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.CreateAppPopupContainer, null));
    }
  }, {
    key: "onViewClick",
    value: function onViewClick(app) {
      this.context.dialogs.custom(_react2.default.createElement(_components.EditAppPopupContainer, {
        id: app.id,
        name: app.name,
        secret: app.secret,
        company: app.company,
        icon: app.icon,
        description: app.description
      }));
    }

    // icon: ?any,
    // title: ?string,
    // appId: ?string,
    // deleting: ?boolean,
    // onDeleteClick: ?Function,
    // onLearnMoreClick: ?Function,

  }, {
    key: "onDeleteClick",
    value: function onDeleteClick(app) {
      this.context.dialogs.custom(_react2.default.createElement(_components.DeleteAppPopup, { appId: app.id, appName: app.name }));

      // this.context.dialogs.prompt(`Would you like to delete following developer app?\n\n${app.name}`)
      // .then((res) => {
      //   if (res) {
      //     this.props.dispatch(deleteApplication(app.id));
      //   }
      // });
    }
  }, {
    key: "renderApplications",
    value: function renderApplications() {
      var _this2 = this;

      var styles = require("./UserApplications.scss");
      var _props = this.props,
          applications = _props.applications,
          loading = _props.loading,
          loaded = _props.loaded;


      return _react2.default.createElement(
        "table",
        { className: styles["table"] + " " + styles["table-striped"] },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "th",
              null,
              "\xA0"
            ),
            _react2.default.createElement(
              "th",
              null,
              "App ID"
            ),
            _react2.default.createElement(
              "th",
              null,
              "App Name"
            ),
            _react2.default.createElement(
              "th",
              null,
              "\xA0"
            )
          )
        ),
        _react2.default.createElement(
          "colgroup",
          null,
          _react2.default.createElement("col", { style: { width: "8.33%" } }),
          _react2.default.createElement("col", { style: { width: "44.44%" } }),
          _react2.default.createElement("col", { style: { width: "22.22%" } }),
          _react2.default.createElement("col", { style: { width: "25%" } })
        ),
        _react2.default.createElement(
          "tbody",
          null,
          applications.map(function (app) {
            return _react2.default.createElement(
              "tr",
              { key: app.id },
              _react2.default.createElement(
                "td",
                null,
                _react2.default.createElement("img", { style: { width: 20, height: 20 }, src: app.icon })
              ),
              _react2.default.createElement(
                "td",
                { className: styles.id },
                app.id
              ),
              _react2.default.createElement(
                "td",
                null,
                app.name
              ),
              _react2.default.createElement(
                "td",
                { style: { float: "right" } },
                _react2.default.createElement(_Button2.default, {
                  small: true,
                  label: "Delete",
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.onDeleteClick(app);
                  },
                  style: { marginRight: 10 }
                }),
                _react2.default.createElement(_Button2.default, {
                  small: true,
                  label: "View",
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.onViewClick(app);
                  }
                })
              )
            );
          })
        )
      );
    }
  }, {
    key: "renderApp",
    value: function renderApp() {
      var _this3 = this;

      var applications = this.props.applications;


      var entries = applications.map(function (app) {
        return [_react2.default.createElement(
          "div",
          null,
          _react2.default.createElement("img", {
            src: app.icon,
            className: (0, _glamor.css)({
              display: "inline-block",
              verticalAlign: "middle",
              width: 24,
              height: 24
            })
          }),
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: (0, _glamor.css)({
              display: "inline-block",
              verticalAlign: "middle",
              padding: "0 0 " + (0, _css.unitRem)(0.0835) + " 0",
              paddingLeft: 8
            }),
            label: app.name,
            mode: "small-white-underlined",
            onClick: function onClick(e) {
              e.preventDefault();
              _this3.onViewClick(app);
            }
          })
        ), _react2.default.createElement(
          "span",
          { className: (0, _glamor.css)({ verticalAlign: "middle" }) },
          app.id
        ), _react2.default.createElement(_components.TextButtonLibrary, {
          className: (0, _glamor.css)({
            display: "inline-block",
            verticalAlign: "middle",
            color: _css.colors.red,
            padding: "0 0 " + (0, _css.unitRem)(0.0835) + " 0"
          }),
          mode: "small-underlined",
          label: "Delete App",
          onClick: function onClick(e) {
            e.preventDefault();
            _this3.onDeleteClick(app);
          }
        })];
      });

      return _react2.default.createElement(_Table2.default, {
        className: table,
        columnTitles: ["App Name", "App ID", "Delete App"],
        entries: entries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require("./UserApplications.scss");
      var _props2 = this.props,
          loading = _props2.loading,
          loaded = _props2.loaded,
          applications = _props2.applications,
          deleting = _props2.deleting;


      return _react2.default.createElement(
        "section",
        { className: tableSection },
        _react2.default.createElement(
          "h1",
          { className: title },
          "Developer Apps"
        ),
        loaded && applications.length !== 0 && this.renderApp(),
        loaded && applications.length !== 0,
        loading && _react2.default.createElement(
          "div",
          { style: { textAlign: "center", marginTop: "2em" } },
          _react2.default.createElement(_components.LoadingIndicator, null)
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _glamor.css)({ color: _css.colors.gray }) },
          _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)({ textAlign: "center" }) },
            _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)({ margin: (0, _css.unitRem)(2) + " 0" }) }),
            loaded && applications.length === 0 && _react2.default.createElement(
              "div",
              {
                style: {
                  marginTop: "2em",
                  color: "white",
                  paddingBottom: (0, _css.unitRem)(2)
                }
              },
              _react2.default.createElement(
                "p",
                null,
                "You have not created any apps yet."
              )
            ),
            _react2.default.createElement(_Button2.default, {
              mode: "secondary",
              label: "Create App",
              onClick: this.onCreateClick.bind(this)
            }),
            _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)({ margin: (0, _css.unitRem)(2) + " 0" }) })
          ),
          _react2.default.createElement(
            "p",
            { style: { margin: "1em 0 2em", lineHeight: "1.5" } },
            "If you're a developer, and want to integrate Megascans into your own tools, create an ",
            _react2.default.createElement(
              "em",
              null,
              "Application"
            ),
            " below ",
            _react2.default.createElement("br", null),
            "to get your application API keys to authenticate users of your application with the Megascans API."
          ),
          _react2.default.createElement(
            "p",
            { style: { margin: "1em 0 2em", lineHeight: "1.5" } },
            "For more details on authentication and the Megascans API, check out the",
            _react2.default.createElement(_components.TextButtonLibrary, {
              mode: "gray-small-underlined",
              label: "documentation.",
              href: "https://quixel.github.io/megascans-api-docs/quick-start-guide/",
              newWindow: true
            })
          )
        )
      );
    }
  }]);
  return UserApplications;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var UserApplicationsContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.applications.applications.loading,
    loaded: state.applications.applications.loaded,
    loadingError: state.applications.applications.loadingError,
    applications: state.applications.applications.applications,

    creating: state.applications.application.creating,
    created: state.applications.application.created,

    deleting: state.applications.application.deleting,
    deleted: state.applications.application.deleted
  };
}), _dec(_class2 = function (_React$Component2) {
  (0, _inherits3.default)(UserApplicationsContainer, _React$Component2);

  function UserApplicationsContainer() {
    (0, _classCallCheck3.default)(this, UserApplicationsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserApplicationsContainer.__proto__ || (0, _getPrototypeOf2.default)(UserApplicationsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserApplicationsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _applications.loadApplications)());
    }
  }, {
    key: "render",
    value: function render() {
      // const applications = [{id: '001', key: 'asdf', name: 'Bridge', company: 'Quixel', description: 'Easily manage all your scans on desk, and export to any renderer.', icon: 'https://megascans.se/icons/bridge.jpg'}, {id: '002', key: 'asdf', name: 'Studio', company: 'Quixel', description: 'Customize and blend surface scans to create stunning tileables.', icon: 'https://megascans.se/icons/studio_64.jpg'}];

      return _react2.default.createElement(UserApplications, this.props);
    }
  }]);
  return UserApplicationsContainer;
}(_react2.default.Component)) || _class2);
exports.default = UserApplicationsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserApplications/UserApplications.jsx
// module id = 2473
// module chunks = 0